<div class="main">
  <p class="text-center">{{ greetingMessage }}</p>
  <button
    mat-button
    color="primary"
    style="
      width: 300px;
      height: 54px;
      padding: 10px, 0px, 10px, 0px;
      border-radius: 5.76px;
      border: 0.72px;
      color: #00498f;
      background: #ffff;
    "
    (click)="onCancelClick()"
  >
    Let's Begin
  </button>
</div>
